import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { submitInquiry } from '@api/inquiries';
import { ISubmitInquiryProps } from '@interfaces/inquiries';

import { buildSubmitInquiryPayload } from './utils';

export const handleSubmitInquiry = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  ISubmitInquiryProps
>('submitInquiry', props => submitInquiry(buildSubmitInquiryPayload(props)));
